
import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import {
  GetAll
} from "adminApi/BookingReport/BookingReportApi";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import feilds from "../json/BookingReportFeilds.json";

const BookingReportTable = ({ filters, date }) => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = feilds

  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Booking CheckOut",
    ...filters,
  });


  // Auto-generate display fields 
  const displayFields = generateDisplayFields(tabledata);



  // Table Hook
  const { formattedData, columns } = useTableConfig({
    data,
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: false,
    IsEdit: false,
    config: {
      entityName: "Booking CheckOut Report",
      editUrl: "",
      idKey: "booking_id",
      deleteApi: () => { },
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => { setPage(p) };

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
        fileName: "Booking CheckOut Report",
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
      isDate={true}
      date={date}
    />
  );
};

export default BookingReportTable;
